import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetChecklistItemsAction implements Action {
  public static readonly type = 'GetChecklistItemsAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = GetChecklistItemsAction.type;
}
